<template>
    <div :class="headerLineWrapStyle">
        <ul class="lineTitle">
            <li class="line"></li>
            <li class="showTitle">{{showTitle}}</li>
            <li class="line"></li>
        </ul>
        <!-- <div class="showTitle">{{showTitle}}</div> -->
        <ul class="title">
            <!-- <li class="line"></li> -->
            <li class="bestText">{{Text}}</li>
            <!-- <li class="line"></li> -->
        </ul>
    </div>
</template>
<script>
export default {
    name: 'Headlines',
    props: {
        Text: {
            type: String,
            default: null
        },
        showTitle: {
            type: String,
            default: null
        },
        headerLineWrapStyle: {
            type: String,
            default: () => {
                return 'headerLineWrapStyle';
            }
        }
    },
    destroyed() {
        this.$refs = null;
        this._self = null;
    }
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';
.headerLineWrapStyle {
    background: #fff;
    padding-top: $rem40;
    height: $rem156;
    padding-bottom: $rem40;
}
.lineTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    height: $rem37;
    padding: $rem16;
}
.line {
    width: $rem16;
    opacity: 1;
    height: $rem2;
    background: #cccccc;
}
.bestText {
    margin-right: $rem30;
    margin-left: $rem30;
    font-family: 'Athelas-Regular';
    color: #999999;
    letter-spacing: $rem12;
    font-size: $rem18;
    line-height: $rem48;
    margin-top: $rem16;
}
.showTitle {
    line-height: $rem56;
    text-align: center;
    padding: 0 $rem16;
    font-family: 'PingFangSC-Light';
    font-size: $rem40;
    color: #333333;
}
</style>
